import api from "../helpers/axios";

class DashboardMetricsService {
    async getKpiSummary(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v3/kpi-summary${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getKpiSummary:`, error);
            throw error;
        }
    }

    async getProjectAnalytics(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v2/projects-analytics${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getProjectAnalytics:`, error);
            throw error;
        }
    }

    async getFileUploadAnalytics(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v3/file-uploads-analytics${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getFileUploadAnalytics:`, error);
            throw error;
        }
    }

    async getWorkspaceAnalytics(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v2/workspace-analytics${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getWorkspaceAnalytics:`, error);
            throw error;
        }
    }

    async getCollectionAnalytics(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v2/collections-analytics${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getCollectionAnalytics:`, error);
            throw error;
        }
    }

    async getFileGenerationAnalytics(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v3/file-generation-analytics${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getFileGenerationAnalytics:`, error);
            throw error;
        }
    }

    async getTokenUsageAnalytics(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v2/token-usage-analytics${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getTokenUsageAnalytics:`, error);
            throw error;
        }
    }

    async getPlatformUsage(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v3/platform-usage-analytics${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getPlatformUsage:`, error);
            throw error;
        }
    }

    async getUserMetrics(queryParams = "") {
        try {
            const response = await api.get(`/dashboard-v3/user-metrics${queryParams}`);
            return response;
        } catch (error) {
            console.error(`Error fetching getUserMetrics:`, error);
            throw error;
        }
    }

    async getAgentAnalytics(payload = {}) {
        try {
            const response = await api.post(`/admin/agents/analytics`, payload);
            return response;
        } catch (error) {
            console.error(`Error fetching getAgentAnalytics:`, error);
            throw error;
        }
    }

    async getCategoryAnalytics(payload = {}) {
        try {
            const response = await api.post(`/admin/agents/analytics/categories`, payload);
            return response;
        } catch (error) {
            console.error(`Error fetching getCategoryAnalytics:`, error);
            throw error;
        }
    }

}

export default new DashboardMetricsService();